import React from 'react';
import { connect } from "react-redux";
import createArticle from './../../../API/Admin/CreateAritcle.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from './../../../Global/loader'

class CreateArticle extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        articleName: "",
        unitOfMeasure: "",
        catalogNumber: "",
        articleCode: "",
        additionalName: "",
        unitQuantity: 0,
        taxRate: "3be1d2a2-504c-4a50-af0e-1d4de8d872b4", //PDV 25%
        taxRate0: "37d7ceea-fba9-47d1-9fb7-3fee5ac67426" // 0% pdv
    }

    componentDidMount = async () => {
        this.setState({
            loading: true
        })

        this.setState({           
            loading: false
        }) 
    }
    
    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }
    
    

    submitCreate = async (e) => {
        this.setState({ loading: true })
        e.preventDefault()

        let porez
        this.props.oneClientInfo.inVatSystem ?
            porez = this.state.taxRate
            :
            porez = this.state.taxRate0
        
        let createPP = await createArticle(
            this.props.oneClientInfo.uuid, 
            this.state.articleName, 
            this.state.unitOfMeasure, 
            this.state.catalogNumber, 
            this.state.articleCode, 
            this.state.additionalName,
            this.state.unitQuantity,            
            porez
        )
        
        if(createPP.data.response){ 
            store.addNotification({
                title: "Greška!",
                message: createPP.data.response.data.message,//"Došlo je do pogreške prilikom kreiranja naplatnog uređaja, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        else{
            store.addNotification({
                title: "Uspješno!",
                message: "Kreiranje artikla je završeno",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.props.goBack()
        }        
    }
   
    render(){  
        return (
            <>
                {this.state.loading ?
                <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                    <Loader />
                </div>
                :
                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="articleName" className="col-sm-4 col-form-label">Naziv</label>
                                <div className="col-sm-8">
                                    <input      
                                            id="articleName"                          
                                            type="text"
                                            value={this.state.articleName}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="unitOfMeasure" className="col-sm-4 col-form-label">Mjerna jedinica</label>
                                <div className="col-sm-8">
                                    <input
                                        id="unitOfMeasure"  
                                        type="text"
                                        value={this.state.unitOfMeasure}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="catalogNumber" className="col-sm-4 col-form-label">Kataloški broj</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="catalogNumber"                         
                                        type="text"
                                        value={this.state.catalogNumber}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="articleCode" className="col-sm-4 col-form-label">Šifra</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="articleCode"                         
                                        type="text"
                                        value={this.state.articleCode}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="form-group row">
                                <label htmlFor="additionalName" className="col-sm-4 col-form-label">Dodatan naziv</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="additionalName"                         
                                        type="text"
                                        value={this.state.additionalName}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="form-group row">
                                <label htmlFor="unitQuantity" className="col-sm-4 col-form-label">Količina</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="unitQuantity"                         
                                        type="number"
                                        value={this.state.unitQuantity}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button                                    
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitCreate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div 
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>    
                
                </form>
                }  
            </>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        onePosPro: state.adminClient.onePosPro
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateArticle);


